import React from 'react';
import styled from 'styled-components';
import { Table } from '../../ui-kit';
import { IconArrowRightLong } from '../../ui-kit/icons';

const ContractConstraintWarning = styled.span`
  color: ${props => (props.satisfied ? '#090' : '#da4f49')};
  display: inline-block;
  font-weight: 600;
`;

const ContractConstraintWarningTemplate = ({ warnings }) => (
  <Table bordered condensed hover>
    <thead>
      <tr>
        <th>{I18n.t('activerecord.models.user')}</th>
        <th>{I18n.t('activerecord.models.reporting/contracts/contract')}</th>
        <th>{I18n.t('activerecord.models.reporting/contracts/contract_type_constraint')}</th>
        <th>{I18n.t('activerecord.attributes.reporting/contracts/contract_type_constraint.min')}</th>
        <th>{I18n.t('activerecord.attributes.reporting/contracts/contract_type_constraint.max')}</th>
        <th>{I18n.t('activerecord.attributes.reporting/contracts/contract_type_constraint.value')}</th>
      </tr>
    </thead>
    <tbody>
      {warnings.map((warning, index) => (
        <tr key={index}>
          <td>
            {warning.user.first_name} {warning.user.last_name}
          </td>
          <td>{warning.contract_type_name}</td>
          <td>{warning.before.name}</td>
          <td>{warning.before.formatted.min}</td>
          <td>{warning.before.formatted.max}</td>
          <td>
            <ContractConstraintWarning satisfied={warning.before.status !== 'unsatisfied'}>
              {warning.before.formatted.value}
            </ContractConstraintWarning>{' '}
            <IconArrowRightLong />{' '}
            <ContractConstraintWarning satisfied={warning.after.status !== 'unsatisfied'}>
              {warning.after.formatted.value}
            </ContractConstraintWarning>
          </td>
        </tr>
      ))}
    </tbody>
  </Table>
);

export default ContractConstraintWarningTemplate;
